import { useUnitOfMeasurementsStore } from "@/stores/unitOfMeasurmentsStore"

export const purcheseOrdersRouteDataPreload = async (): Promise<void> => {
  await useUnitOfMeasurementsStore.getState().getUnits()
}
